export default __webpack_public_path__ + "static/media/BrainBreak cards49.30c17847.png";